import { CompanySelectInput } from "../../components/form/company-dropdown";
import { RedemptionHistoryCard } from "../../components/gift-cards/redemption-history-card";
import { PortalMainLayout } from "../../components/layout/portal-main-layout";
import { ToggleView } from "../../components/views/toggle-view";
import { useRedemptionHistory } from "../../hooks/use-redemption-history";
import { AuthorisedPage } from "../auth/authorised-page";

// ---------------------------------------------------------------------------
// Print styles — scoped class names (rh-*) avoid collisions with other pages
// ---------------------------------------------------------------------------
const mainWrap =
  "flex max-w-[980px] min-[880px]:ml-24 px-[12px] pt-[18px] min-[880px]:px-9 min-[880px]:pt-7";

const PrintStyles = () => (
  <style>{`
    @media print {
      /* 1. Let the full list render — removes the viewport-height clip on <main> */
      html, body { overflow: visible !important; height: auto !important; }
      main        { max-height: none !important; overflow: visible !important; height: auto !important; }

      /* 2. Hide chrome: side nav, bottom tab bar, company selector */
      nav, aside  { display: none !important; }
      .fixed      { display: none !important; }

      /* 3. Remove screen-only spacing */
      .rh-wrapper { margin-top: 0.5rem !important; margin-bottom: 0 !important; overflow: visible !important; }

      /* 3b. Sticky header would pin to every page — flatten it */
      .rh-header { position: static !important; padding-bottom: 0 !important; }

      /* 4. Cards: prevent mid-page splits, flip to light theme */
      .rh-card      { break-inside: avoid; page-break-inside: avoid; background: #fff !important; color: #000 !important; box-shadow: none !important; outline: none !important; border: 1px solid #ccc !important; }
      .rh-card span { color: #000 !important; }
      .rh-card img  { filter: invert(1); }

      /* 5. Status badges need a visible border on white paper */
      .rh-card [class*="rounded-full"] { border: 1px solid #555 !important; }
    }
  `}</style>
);

// ---------------------------------------------------------------------------
// Page
// ---------------------------------------------------------------------------
export const RedemptionHistoryPage = () => {
  const {
    data,
    unauthorised,
    selectedCompany,
    companyOptions,
    onSetTargetCompany,
  } = useRedemptionHistory();

  return (
    <AuthorisedPage>
      <PortalMainLayout isUnauthorised={unauthorised.show}>
        <div
          id="redemption-history-header"
          className="rh-header sticky top-0 z-40 bg-black pb-[10px]"
        >
          <div className={mainWrap}>
            <div className="flex items-center gap-[12px] mt-[4px] mx-[4px]">
              <h1 className="m-0 text-[26px] font-bold font-headings-primary tracking-[-0.01em] text-white">
                History
              </h1>
            </div>
          </div>

          {/* Own full-width row so mx-auto centres on the page, not in the
              leftover space beside the title. Left pad clears the side menu. */}
          <div className="md:mt-[-50px] mt-[12px] ">
            <div className="mx-auto w-full max-w-[640px]">
              <CompanySelectInput
                dataModel={selectedCompany}
                {...companyOptions}
                onChange={onSetTargetCompany}
                customClassName="!rounded-xl"
              />
            </div>
          </div>
        </div>

        <ToggleView show={companyOptions} />

        <PrintStyles />

        <div id="redemption-history-content" className="rh-wrapper overflow-x-auto mb-[200px] mt-[1rem]">
          <div className="rh-list space-y-2 w-full md:w-3/4 mx-auto max-w-[640px] md:ml-[2rem] px-2 my-2">
            {data.map((row, index) => (
              <RedemptionHistoryCard key={index} row={row} />
            ))}
          </div>
        </div>

      </PortalMainLayout>
    </AuthorisedPage>
  );
};
